import { Drawer } from 'antd'
import styled from 'styled-components'

const StyledDishDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0;
  }

  .ant-table-cell {
    padding: 3px 8px !important;
  }

  &.ant-table {
    margin: 0 !important;
  }
`

export default StyledDishDrawer
